/**
 * KunstPfote – generiertes Porträt auf den Produktkarten
 *
 * Hat ein Besucher für ein Motiv schon eine Vorschau erzeugt, zeigt die Produktkarte dieses Motivs
 * (Kollektionsseiten, Startseite, Empfehlungen, Suche) statt des Beispielbilds sein eigenes Porträt.
 *
 * Zuordnung: snippets/card-gallery.liquid setzt data-kp-motiv auf die Karte – das SKU-Präfix der
 * ersten Variante (z. B. KP-BATHTIME), genau wie personalization-form.liquid es als Motiv verwendet.
 * Das Porträt liegt unter {uploadBase}/image/{sessionId}/generated/{motiv}.jpg (Vorschau mit Wasserzeichen).
 *
 * Reagiert auf neue Generierungen, gelöschte Porträts, andere Tabs (storage) und nachgeladene Karten
 * (Filter, Paginierung, Empfehlungen) per MutationObserver.
 */
(() => {
  if (window.__kpCardPortrait) return;
  window.__kpCardPortrait = true;

  const UPLOAD_DATA_KEY = 'kunstpfote_uploads';
  const DEFAULT_BASE = 'https://upload.kunstpfote.de';
  const ATTR = 'data-kp-portrait';
  const failed = new Set(); // Bilder, die nicht mehr existieren (abgelaufene Session) – nicht erneut versuchen

  function readPortraits() {
    const map = new Map();
    try {
      const d = JSON.parse(localStorage.getItem(UPLOAD_DATA_KEY) || 'null');
      if (!d?.sessionId || !Array.isArray(d.generated)) return map;
      const base = (d.uploadBase || DEFAULT_BASE).replace(/\/$/, '');
      for (const e of d.generated) {
        const sku = typeof e === 'string' ? e.replace(/\.jpg$/i, '') : e?.sku;
        if (!sku || sku === 'undefined') continue;
        const src = `${base}/image/${d.sessionId}/generated/${sku}.jpg`;
        if (!failed.has(src)) map.set(sku.toUpperCase(), src);
      }
    } catch (e) {}
    return map;
  }

  /** Erstes (sichtbares) Bild der Karte */
  function cardImage(card) {
    return card.querySelector('slideshow-slide:not([hidden]) img') || card.querySelector('img');
  }

  function apply(card, src) {
    const img = cardImage(card);
    if (!img) return;

    if (!img.hasAttribute('data-kp-original-src')) {
      img.setAttribute('data-kp-original-src', img.getAttribute('src') || '');
      img.setAttribute('data-kp-original-srcset', img.getAttribute('srcset') || '');
      img.setAttribute('data-kp-original-sizes', img.getAttribute('sizes') || '');
      img.setAttribute('data-kp-original-alt', img.getAttribute('alt') || '');
    }
    if (img.getAttribute(ATTR) === src) return;

    // Erst laden, dann tauschen – kein leeres Bild, falls die Datei fehlt
    const probe = new Image();
    probe.onload = () => {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = src;
      img.alt = 'Dein Porträt (Vorschau)';
      img.setAttribute(ATTR, src);
      card.setAttribute(ATTR, '');
    };
    probe.onerror = () => {
      failed.add(src);
      restore(card);
    };
    probe.src = src;
  }

  function restore(card) {
    const img = card.querySelector(`img[${ATTR}]`);
    card.removeAttribute(ATTR);
    if (!img) return;
    const srcset = img.getAttribute('data-kp-original-srcset');
    const sizes = img.getAttribute('data-kp-original-sizes');
    if (srcset) img.setAttribute('srcset', srcset);
    if (sizes) img.setAttribute('sizes', sizes);
    img.src = img.getAttribute('data-kp-original-src');
    img.alt = img.getAttribute('data-kp-original-alt');
    img.removeAttribute(ATTR);
  }

  function update(root = document) {
    const portraits = readPortraits();
    root.querySelectorAll?.('[data-kp-motiv]').forEach((card) => {
      const motiv = (card.getAttribute('data-kp-motiv') || '').toUpperCase();
      const src = motiv && portraits.get(motiv);
      if (src) apply(card, src);
      else if (card.hasAttribute(ATTR)) restore(card);
    });
  }

  const run = () => update();
  window.addEventListener('kunstpfote:generation-complete', run);
  window.addEventListener('kunstpfote:generated-removed', run);
  window.addEventListener('storage', (e) => { if (e.key === UPLOAD_DATA_KEY) run(); });
  window.addEventListener('pageshow', run); // Zurück-Button (bfcache)

  // Nachgeladene Karten (Filter, Paginierung, Empfehlungen, Suche)
  let pending = false;
  new MutationObserver((mutations) => {
    if (pending) return;
    if (!mutations.some((m) => [...m.addedNodes].some((n) => n.nodeType === 1))) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; run(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
